import { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useContext } from '../context.jsx';
import { SidePanel } from '../../../components/side-panel/SidePanel.jsx';
import { EmptySidePanel } from '../../../components/side-panel/EmptySidePanel.jsx';
import { CollapsibleSection } from '../../../components/side-panel/CollapsibleSection.jsx';
import { LimeFieldInputs } from './LimeFieldInputs.jsx';
import { PhosphorusPotassiumFieldInputs } from './PhosphorusPotassiumFieldInputs.jsx';

export function FieldSidePanel(props) {
  const { close, field } = props;
  const { tab, getInstancesForField, setFocusedInstanceId, focusedInstanceId } =
    useContext();
  const [expandedIds, setExpandedIds] = useState([]);

  const instances = useMemo(
    () => field && getInstancesForField(field, tab),
    [field, getInstancesForField, tab],
  );

  return (
    <SidePanel title="Instance Inputs" subtitle={field?.name} close={close}>
      {buildDetails()}
    </SidePanel>
  );

  function buildDetails() {
    if (!field) return <EmptySidePanel />;

    if (!instances?.length)
      return <EmptySidePanel message="No instances found for this field" />;

    return instances.map((instance) => (
      <CollapsibleSection
        key={instance.id}
        expanded={expandedIds.includes(instance.id)}
        onChange={handleAccordionChange(instance.id)}
        className={instance.id === focusedInstanceId ? 'focused' : ''}
        title={
          <span>
            {instance.name}
            {instance.isApplied ? (
              <Typography
                component="span"
                sx={{ fontWeight: 400, color: 'text.secondary', ml: 1 }}
              >
                (Applied)
              </Typography>
            ) : (
              ''
            )}
          </span>
        }
      >
        <Box
          sx={{ cursor: 'pointer' }}
          onClick={() => setFocusedInstanceId(instance.id)}
          data-testid="instance-inputs"
        >
          {tab === 'L' && <LimeFieldInputs instance={instance} />}
          {tab === 'P' && (
            <PhosphorusPotassiumFieldInputs
              nutrient="phosphorus"
              instance={instance}
            />
          )}
          {tab === 'K' && (
            <PhosphorusPotassiumFieldInputs
              nutrient="potassium"
              instance={instance}
            />
          )}
        </Box>
      </CollapsibleSection>
    ));
  }

  function handleAccordionChange(id) {
    return (event, isExpanded) => {
      setExpandedIds((prev) =>
        isExpanded ? [...prev, id] : prev.filter((x) => x !== id),
      );
    };
  }
}
